import throttle from 'lodash/throttle'
import API from './api'
import { getCookie, setCookie, animate, getOffset, scrollTo, generateAffiliateUrl, selectAffiliate } from './utils'
import messages from './messages'
import { toast } from 'react-toastify'
import { FormattedMessage } from 'react-intl'
import PriceConverter from './components/helpers/PriceConverter'

export function headerDirective() {
  let items = document.querySelectorAll('[mobile-hover]')
  let mobileExpandableItems = document.querySelectorAll('[expandable-item]')
  let delay = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 0 : 500

  items.forEach(function(item) {
    let timer, leaveTimer

    item.addEventListener('mouseenter', function() {
      clearTimeout(leaveTimer)
      timer = setTimeout(function() {
        item.classList.add('active')
      }, delay)
    })
    item.addEventListener('mouseleave', function() {
      clearTimeout(timer)
      leaveTimer = setTimeout(function() {
        item.classList.remove('active')
      }, delay)
    })
  })

  mobileExpandableItems.forEach(function(item) {
    item.addEventListener('click', function() {
      this.classList.toggle('active')
    })
  })
}

export function convertDjangoRenderedPrice(renderElement) {
  let prices = document.querySelectorAll('[data-price-block]')
  if(prices) {
    prices.forEach(function(item) {
      let currency = item.dataset.shopCurrency
      let price = item.dataset.price
      renderElement(item, PriceConverter, { amount: +price, currency })
    })
  }
}

export function currencyDirective(callback) {
  let items = document.querySelectorAll('.currency-item')
  let displayedCurrency = document.getElementById('selected-currency')
  let mobileCurrency = document.getElementById('currency-select')
  let selectedCurrency = getCookie('currency_code')

  onClick('.currency-item', function(item) {
    selectedCurrency = item.dataset.currencyTitle
    changeCurrency()
    mobileCurrency.value = selectedCurrency
  })

  if(mobileCurrency) {
    mobileCurrency.onchange = function() {
      selectedCurrency = mobileCurrency.value
      changeCurrency()
    }
  }

  function changeCurrency() {
    setCookie('currency_code', selectedCurrency, { path: '/' })

    items.forEach(function(item) {
      if(selectedCurrency !== item.dataset.currencyTitle) {
        item.classList.remove('selected')
      } else {
        item.classList.add('selected')
      }
    })

    if(callback) {
      callback(selectedCurrency)
    }

    document.querySelectorAll('.eur').forEach(item => {
      item.classList.remove('active')
    })

    displayedCurrency.innerHTML = selectedCurrency
  }
}

export function mobileHeader() {
  let elements = document.querySelectorAll('[mobile-menu] li:not(.do-not-trigger)')
  let menu = document.querySelector('.toggle-menu')
  let bodyElem = document.querySelectorAll('html, body')
  let backIcon = document.querySelector('.mobile-back-icon')
  let mobileHeader = document.querySelector('.mobile-header')
  let mobileLogo = document.querySelector('.mobile-header .logo')
  let searchPageItems = document.querySelectorAll('.do-not-trigger')
  let activeTab;
  ['click', 'ontouchstart'].forEach(function(evt) {
    elements.forEach(function(elem) {
      elem.addEventListener(evt, clickingCallback, false)
    })
  });

  ['touchend', 'click'].forEach(function(evt) {
    if(backIcon) { backIcon.addEventListener(evt, hideMenu, false) }
    searchPageItems.forEach(function(item) {
      item.addEventListener(evt, function() {
        if(activeTab) {
          hideMenu()
        }
      }, false)
    })
  })

  function hideMenu() {
    activeTab = null
    elements.forEach(function(elem) {
      elem.classList.remove('active')
    })
    menu.style.display = 'none'
    bodyElem.forEach(function(elem) {
      elem.classList.remove('body-hidden')
    })
    backIcon.style.display = 'none'

    setTimeout(function() {
      mobileLogo.style.display = 'block'
    }, 50)
  }

  function clickingCallback(e) {
    let _this = e.currentTarget
    let menuOffset = getOffset(mobileHeader).top + mobileHeader.clientHeight
    e.preventDefault()
    elements.forEach(function(elem) {
      elem.classList.remove('active')
    })

    document.querySelectorAll('.js-header-mobile > div').forEach(function(item) {
      item.style.display = 'none'
    })

    if(activeTab === _this.dataset.item.toString()) {
      hideMenu()

      return true
    }

    if((menu.style.display === 'none' || menu.style.display === '') && !activeTab) {
      _this.classList.add('active')

      bodyElem.forEach(function(elem) {
        elem.classList.add('body-hidden')
      })

      menu.classList.add('active')
      menu.style.display = 'block'
      menu.style.top = `${menuOffset}px`
      mobileLogo.style.display = 'none'
      backIcon.style.display = 'inline-block'
    } else if(menu.style.display && activeTab) {
      _this.classList.add('active')
      menu.style.display = 'block'
      mobileLogo.style.display = 'none'
      backIcon.style.display = 'inline-block'
    }

    activeTab = _this.dataset.item.toString()

    document.querySelector('.js-header-mobile .' + activeTab).style.display = 'block'

    return false
  }
}

export function stickyNavigation() {
  const elem = document.querySelector('[sticky-top]')
  if(elem) {
    const trigger = elem.getAttribute('trigger')
    const clickable = elem.getAttribute('clickable')

    let position = 0; let triggerElement

    if(trigger) {
      triggerElement = document.querySelector(trigger)

      position = triggerElement.offsetHeight + getOffset(triggerElement).top
    }

    if(clickable) {
      elem.addEventListener('click', function() {
        if(trigger) {
          window.scrollTo(0, getOffset(triggerElement).top)
        } else {
          window.scrollTo(0, 0)
        }
      })
    }

    const throttledScroll = throttle(function() {
      if(window.scrollY > position) {
        elem.classList.add('active')
      } else if(elem.classList.contains('active')) {
        let margin = -5
        animate(function() {
          elem.style.marginTop = margin + 'px'

          margin -= 5
        }, 300, function() {
          elem.style.marginTop = ''
          elem.classList.remove('active')
        })
      }
    }, 300)

    window.onscroll = throttledScroll
  }
}

export function wishlistDirective(intl) {
  const popup = document.getElementById('wishlist-popup')

  document.getElementById('close-wishlist').addEventListener('click', function() {
    popup.style.left = '-9999px'
  })

  onClick('.heart', triggerWishlist)
  onClick('.wishlist-btn', triggerWishlist)
  onClick('.btn-wishlist-mobile', triggerWishlist)

  function triggerWishlist(elem, event) {
    event.stopPropagation()
    event.preventDefault()

    const elemOffset = getOffset(elem)
    console.log('click')
    if(!window.loggedUser) {
      const wishlistPopupWidth = popup.offsetWidth
      const parentPosition = elemOffset.left
      if(parentPosition - wishlistPopupWidth < 0) {
        popup.style.left = (elemOffset.left + elem.offsetWidth - wishlistPopupWidth) + 'px'
        popup.style.top = (elemOffset.top - popup.clientHeight - 20) + 'px'
      } else {
        popup.style.left = (elemOffset.left - wishlistPopupWidth - 20) + 'px'
        popup.style.top = (elemOffset.top - popup.clientHeight / 2) + 'px'
      }
    } else {
      var data = {
        item_type: elem.dataset.type,
        item_slug: elem.dataset.shopSlug,
      }
      var type = 'add'

      if(elem.dataset.inWishlist) {
        data = elem.dataset.wishlistId
        type = 'delete'
      }

      if(type === 'add') {
        API('account/wishlist/add/', false, true)
          .post(data)
          .then(function(res) {
            elem.dataset.inWishlist = true
            elem.dataset.wishlistId = res.item.id

            elem.classList.add('active')

            if(elem.getAttribute('single-shop')) {
              elem.innerHTML = `<i class="font-icons heart-icon"></i>${intl.formatMessage(messages.removeFromWishlist)}`
            }
          })
      } else {
        API(`account/wishlist/delete/${data}/`, false, true)
          .delete(data)
          .then(function(res) {
            elem.dataset.inWishlist = ''

            elem.classList.remove('active')

            if(elem.getAttribute('single-shop')) {
              elem.innerHTML = `<i class="font-icons heart-icon"></i>${intl.formatMessage(messages.addToWishlist)}`
            }
          })
      }
    }
  }
}

function onClick(selector, callback) {
  document.addEventListener('click', function(event) {
    var selectors = document.querySelectorAll(selector)
    var element = event.target
    var index = -1
    if(selectors) {
      while(element && ((index = Array.prototype.indexOf.call(selectors, element)) === -1)) {
        element = element.parentElement
      }

      if(index > -1) {
        callback.call(this, element, event)
      }
    }
  })
}

export function collapseItems() {
  const elements = document.querySelectorAll('.collapsable')

  elements.forEach((elem) => {
    let collapsableTrigger = elem.querySelector('.collapsable-trigger')
    let container = elem.querySelector('.collapsable-content')

    if(elem.getAttribute('expanded')) {
      elem.classList.remove('collapsed')
      DOMAnimations.slideDown(container)
    } else {
      elem.classList.add('collapsed')
      DOMAnimations.slideUp(container)
    }
    collapsableTrigger.addEventListener('click', function(e) {
      e.preventDefault()
      DOMAnimations.slideToggle(container)
      elem.classList.toggle('collapsed')
    })
  })
}

export function openToggler() {
  const elements = document.querySelectorAll('[open-toggler]')

  elements.forEach((elem) => {
    let sectionToToggle = document.querySelector(elem.getAttribute('open-toggler'))

    elem.addEventListener('click', function(e) {
      elem.classList.toggle('active')
      if(elem.classList.contains('active')) {
        elem.innerText = elem.getAttribute('hide-text')
      } else {
        elem.innerText = elem.getAttribute('read-more-text')
      }
      sectionToToggle.classList.toggle('hidden-elem')
    })
  })
}

export function hideTopBanner() {
  const isHidden = sessionStorage.getItem('hideModal')
  if(isHidden) {
    const flashSale = document.querySelectorAll('.flash-sale')
    flashSale && flashSale.forEach(item => {
      item.style.display = 'none'
    })
  }

  const menu = document.querySelector('.toggle-menu')
  const mobileHeader = document.querySelector('.mobile-header')
  onClick('.flash-sale .close-icon', function(item) {
    DOMAnimations.slideUp(item.parentElement)
    sessionStorage.setItem('hideModal', true)
    setTimeout(() => {
      const menuOffset = getOffset(mobileHeader).top + mobileHeader.clientHeight
      menu.style.top = `${menuOffset}px`
    }, 500)
  })
}

export function smoothScroll() {
  const header = document.querySelector('.pt-sticky-top')
  let headerHeight = 0

  onClick('[smooth-scroll]', function(item, e) {
    e.preventDefault()
    e.stopPropagation()
    const hrefAttr = item.getAttribute('scroll-to') || item.getAttribute('href')
    const clickAttr = item.hasAttribute('emulate-click')
    const scrollOffset = item.getAttribute('scroll-offset') || 0

    if(header) {
      headerHeight = header.offsetHeight
    }

    if(hrefAttr) {
      const elementToScroll = document.querySelector(hrefAttr)
      const collapsableContainer = elementToScroll.querySelector('.collapsable.collapsed')
      if(elementToScroll) {
        if(hrefAttr[0] === '#' && !item.getAttribute('notPrevent')) {
          window.location.hash = hrefAttr.substr(1)
        }

        const offset = getOffset(elementToScroll).top - headerHeight - scrollOffset
        scrollTo(document.documentElement, offset, 150)

        // works only with collapsable directive;
        if(clickAttr && collapsableContainer) {
          elementToScroll.querySelector('.collapsable-trigger').click()
        }
      }
    }
  })
}

export function changeAffiliateDirective() {
  onClick('.affiliate-row-data', function(item) {
    const { title, id } = item.dataset

    console.log(title, id)
    selectAffiliate(id)
  })
}

export function copyAffiliateLink() {
  const copyButton = document.querySelector('[copy-affiliate-link]')

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.opacity = 0
    textArea.style.position = 'absolute'
    textArea.style.top = '-999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      toast.success(<FormattedMessage id='link_copied' defaultMessage='Link was copied to your clipboard' />)
    } catch (err) {
    }

    document.body.removeChild(textArea)
  }

  function copyTextToClipboard(text) {
    if(!navigator.clipboard) {
      fallbackCopyTextToClipboard(text)
      return
    }
    navigator.clipboard.writeText(text).then(function() {
      toast.success(<FormattedMessage id='link_copied' defaultMessage='Link was copied to your clipboard' />)
    }, function(err) {
      console.error('Async: Could not copy text: ', err)
    })
  }

  if(copyButton) {
    copyButton.addEventListener('click', function() {
      API('url-shortner/').post({
        longUrl: generateAffiliateUrl(),
      }).then(data => copyTextToClipboard(data.shortUrl))
    })
  }
}

export function shareAffiliate() {
  const shareAffiliateContainer = document.querySelector('share-affiliate')

  if(shareAffiliateContainer) {
    API('url-shortner/').post({
      longUrl: generateAffiliateUrl(),
    }).then(function(data) {
      return encodeURIComponent(data.shortUrl)
    }).then(function(affiliateLink) {
      shareAffiliateContainer.innerHTML = `<div class="share-block">
        <a target="_blank" href="https://www.facebook.com/sharer.php?u=${affiliateLink}"><i class="font-icons fb-icon"></i>Facebook</a>
        <a target="_blank" href="https://twitter.com/intent/tweet?url=${affiliateLink}"><i class="font-icons twitter-icon"></i>Twitter</a>
        <a target="_blank" href="https://www.pinterest.com/pin/create/button/?url=${affiliateLink}&media=https%3A//s.diviac.com/travel_dist/images/padi_travel_social_default.jpg&description="><i class="font-icons icon-pinterest"></i>Pinterest</a>
        <a target="_blank" href="https://www.linkedin.com/shareArticle?mini=true&url=${affiliateLink}&title=PADI%20Travel&summary=PADI%20Travel&source="><i class="font-icons icon-linkedin"></i>Linkedin</a>
      </div>`
    })
  }
}

export function abTest(id) {
  if(window.google_optimize && window.google_optimize.get(id) === '1') {
    const textToRemove = document.getElementById('experiment-row')
    if(textToRemove) {
      textToRemove.remove()
    }
  }
}

export function collectionDescriptionMargin() {
  let collecitionDescription = document.getElementById('collection-description')
  if(collecitionDescription) {
    if(window.innerWidth >= 1024) {
      collecitionDescription.style.marginTop = `-${collecitionDescription.clientHeight / 2}px`
    }
    window.addEventListener('resize', function() {
      if(window.innerWidth < 1024) {
        collecitionDescription.style.marginTop = ''
      } else {
        collecitionDescription.style.marginTop = `-${collecitionDescription.clientHeight / 2}px`
      }
    })
  }
}

export function toggleDestinations() {
  const destinationsList = document.querySelectorAll('.destinations-list__details')

  document.addEventListener('click', (e) => {
    let elem = e.target
    let parents = []
    let clickedInside = false
    while(elem) {
      parents.unshift(elem)
      elem = elem.parentNode
    }
    parents.forEach(elem => {
      if(elem.classList &&
        (elem.classList.contains('destinations-list__item__title'))) {
        clickedInside = true
        const parent = elem.parentElement
        const list = parent.querySelector('.destinations-list__details')
        parent.classList.toggle('active')
        DOMAnimations.slideToggle(list, 300)
        if(parent.classList.contains('active')) {
          destinationsList.forEach((item) => {
            if(item !== list) {
              item.parentElement.classList.remove('active')
              DOMAnimations.slideUp(item, 300)
            }
          })
        }
      }
    })
    if(!clickedInside) {
      destinationsList.forEach((item) => {
        item.parentElement.classList.remove('active')
        DOMAnimations.slideUp(item, 300)
      })
    }
  })
}

export function headerDestinationToggle() {
  onClick('#header_operator_toggler .option', function(item) {
    const toggler = item.parentElement
    const container = item.parentElement.parentElement
    if(!item.classList.contains('active')) {
      toggler.getElementsByClassName('active')[0].classList.toggle('active')
      item.classList.toggle('active')
      container.getElementsByClassName('country-list-wrapper').forEach((item) => {
        item.classList.toggle('active')
      })
    }
  })
}

const DOMAnimations = {

  /**
  * SlideUp
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideUp: function(element, duration = 500) {
    return new Promise(function(resolve, reject) {
      element.style.height = element.offsetHeight + 'px'
      element.style.transitionProperty = `height, margin, padding`
      element.style.transitionDuration = duration + 'ms'
      element.offsetHeight
      element.style.overflow = 'hidden'
      element.style.height = 0
      element.style.paddingTop = 0
      element.style.paddingBottom = 0
      element.style.marginTop = 0
      element.style.marginBottom = 0
      window.setTimeout(function() {
        element.style.display = 'none'
        element.style.removeProperty('height')
        element.style.removeProperty('padding-top')
        element.style.removeProperty('padding-bottom')
        element.style.removeProperty('margin-top')
        element.style.removeProperty('margin-bottom')
        element.style.removeProperty('overflow')
        element.style.removeProperty('transition-duration')
        element.style.removeProperty('transition-property')
        resolve(false)
      }, duration)
    })
  },

  /**
  * SlideDown
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideDown: function(element, duration = 500) {
    return new Promise(function(resolve, reject) {
      element.style.removeProperty('display')
      let display = window.getComputedStyle(element).display

      if(display === 'none') {
        display = 'block'
      }

      element.style.display = display
      let height = element.offsetHeight
      element.style.overflow = 'hidden'
      element.style.height = 0
      element.style.paddingTop = 0
      element.style.paddingBottom = 0
      element.style.marginTop = 0
      element.style.marginBottom = 0
      element.offsetHeight
      element.style.transitionProperty = `height, margin, padding`
      element.style.transitionDuration = duration + 'ms'
      element.style.height = height + 'px'
      element.style.removeProperty('padding-top')
      element.style.removeProperty('padding-bottom')
      element.style.removeProperty('margin-top')
      element.style.removeProperty('margin-bottom')
      window.setTimeout(function() {
        element.style.removeProperty('height')
        element.style.removeProperty('overflow')
        element.style.removeProperty('transition-duration')
        element.style.removeProperty('transition-property')
      }, duration)
    })
  },

  /**
  * SlideToggle
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideToggle: function(element, duration = 500) {
    if(window.getComputedStyle(element).display === 'none') {
      return this.slideDown(element, duration)
    } else {
      return this.slideUp(element, duration)
    }
  },
}
